import NotificationsActive from '@mui/icons-material/NotificationsActive';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function NotificationsActiveIcon(props: FixMe) {
  return <NotificationsActive {...props} />;
}

export default NotificationsActiveIcon;
